import StaticContentMapper from './static-content-mapper';
import DescriptionModel from '../description/description-model';
import HeaderModel from '../header/header-model';

const StaticContentModel = {
    mapper: StaticContentMapper,

    description: {
        model: DescriptionModel,
        type: Object,
    },

    header: {
        model: HeaderModel,
        type: Object,
    },
};

export default StaticContentModel;
